import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Avatar from "@mui/material/Avatar";
import MenuItem from "@mui/material/MenuItem";
import MenuUser from "./MenuUser";
import { SubscriptionContent } from "./SubscriptionContent";
import { SubscriptionTier } from "../../proto/api_pb";
import { useNavigate } from "react-router-dom";
import React from "react";
import { AccountMenuProps } from "./types";
import { responsiveAppBarStyles } from "./styles";
import { APP_COLOR, FONT_FAMILY, TEXT_COLOR } from "../../theme";

export const AccountMenu: React.FC<AccountMenuProps> = ({
  handleOpenUserMenu,
  user,
  currentUser,
  anchorElUser,
  userMenu,
  setAnchorElUser,
  handleCloseUserMenu,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <Box sx={{ display: "flex" }}>
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
          <Avatar
            sx={{ bgcolor: APP_COLOR }}
            alt={
              (user?.name?.charAt(0)?.toUpperCase() ?? "") +
              (user?.name?.slice(1) ?? "")
            }
            src={
              currentUser?.getProfilePicture() ?? "/static/images/avatar/2.jpg"
            }
          />
        </IconButton>
        <SubscriptionContent
          subscriptionTier={
            currentUser?.getSubscriptionTier() ??
            SubscriptionTier.SUBSCRIPTION_TIER_UNSPECIFIED
          }
        />
        <Menu
          sx={{ mt: { xs: "40px", sm: "48px", color: "white" } }}
          id="menu-appbar"
          anchorEl={anchorElUser}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          keepMounted
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          open={Boolean(anchorElUser)}
          onClose={() => setAnchorElUser(null)}
        >
          {userMenu.map((setting: any) =>
            typeof setting.value === "string" ? (
              <MenuItem
                sx={{ color: "white", backgroundColor: "inherit" }}
                key={setting.id}
                onClick={() => {
                  if (
                    setting.value !== "Log Out" &&
                    typeof setting.value === "string"
                  ) {
                    if (setting.value === "My NFTs") {
                      navigate(`/my-nfts`);
                    } else {
                      navigate(
                        `/${setting.route.replace(/ /g, "").toLowerCase()}`
                      );
                    }
                  }
                  handleCloseUserMenu(setting);
                }}
              >
                <Typography
                  component={"span"}
                  fontFamily={`${FONT_FAMILY}`}
                  textAlign="center"
                  fontSize="15px"
                  color={TEXT_COLOR}
                >
                  {setting.value}
                </Typography>
              </MenuItem>
            ) : setting.id === 1 ? (
              <Box key={setting.id}>
                <MenuItem
                  onClick={() => {
                    navigate(`/user-profile/${currentUser?.getUsername()}`);
                    handleCloseUserMenu(setting);
                  }}
                  sx={{ backgroundColor: "inherit" }}
                  disableRipple
                >
                  <Box component="span" color={TEXT_COLOR}>
                    <MenuUser
                      imageUrl={
                        currentUser?.getProfilePicture() ??
                        "/static/images/avatar/2.jpg"
                      }
                      user={
                        currentUser
                          ? currentUser?.getFirstName() +
                            " " +
                            currentUser?.getLastName()
                          : (user?.name?.charAt(0)?.toUpperCase() ?? "") +
                            (user?.name?.slice(1) ?? "")
                      }
                      subscriptionTier={
                        currentUser?.getSubscriptionTier() ??
                        SubscriptionTier.SUBSCRIPTION_TIER_UNSPECIFIED
                      }
                    />
                  </Box>
                </MenuItem>
                <hr style={responsiveAppBarStyles.hr} />
              </Box>
            ) : (
              <MenuItem
                key={setting.id}
                onClick={() => handleCloseUserMenu(setting)}
              >
                <Box
                  component="span"
                  marginLeft="-9px"
                  marginRight="-9px"
                  marginBottom="0px"
                  color="white"
                ></Box>
              </MenuItem>
            )
          )}
        </Menu>
      </Box>
    </>
  );
};
